import React from 'react';
import { Link } from 'react-router-dom';
import { FaHome } from 'react-icons/fa';
import PageHeader from '../components/layout/PageHeader';
import pageContent from '../cms/page-content.json';
import RichText from '../components/ui/RichText';
import '../css/pages/NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-page">
      <PageHeader 
        title={pageContent.nfTitle} 
        subtitle={pageContent.nfSubtitle} 
      />
      <div className="not-found-content">
        <div className="not-found-message">
          <h2>{pageContent.nfHeading}</h2>
          <RichText value={pageContent.nfBody} />
        </div>
        
        <div className="not-found-actions">
          <Link to="/" className="btn btn-primary">
            <FaHome style={{ marginRight: '0.5rem' }} />
            {pageContent.nfButtonText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;